import { render } from "./Informes.vue?vue&type=template&id=7fd233c5&scoped=true"
import script from "./Informes.vue?vue&type=script&lang=js"
export * from "./Informes.vue?vue&type=script&lang=js"

import "./Informes.vue?vue&type=style&index=0&id=7fd233c5&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd233c5"]])

export default __exports__